import React from "react";
import { AlertTriangle } from "lucide-react";

export default function VerifyNotice({ items = [], testId = "verify-notice" }) {
  const list = Array.isArray(items) ? items.filter(Boolean) : [items].filter(Boolean);
  if (list.length === 0) return null;
  return (
    <div className="rounded-2xl border border-amber-200 bg-amber-50 p-4" data-testid={testId}>
      <p className="flex items-center gap-2 text-sm font-semibold text-amber-900">
        <AlertTriangle className="h-4 w-4" aria-hidden="true" />
        Please verify this information before publishing
      </p>
      <ul className="mt-2 list-inside list-disc space-y-1 text-sm text-amber-900/85">
        {list.map((v) => {
          const label = typeof v === "string" ? v : JSON.stringify(v);
          return <li key={label}>{label}</li>;
        })}
      </ul>
    </div>
  );
}
